import {create} from 'zustand';
import moment from 'moment';
import lscache from 'lscache';
import tz from 'moment-timezone';
import {buildComparisonPeriod} from '../components/helpers/comparisonPeriod';

// Using Zustand slicing pattern https://docs.pmnd.rs/zustand/guides/slices-pattern
import {onboardingSlice} from './onboardingSlice';
import {adsTxtSlice} from './adsTxtSlice';
import {ticketsSlice} from './ticketsSlice';
import {realtimeSlice} from './realtimeSlice';
import {stackedReportSlice} from './stackedReportSlice';

// Additional time altering logic to prevent marking ad units as inactive if the data is not on our servers yet
let startingDay =
  parseInt(moment.tz('Europe/Vilnius').format('HH')) > 7 ? moment() : moment().subtract(1, 'day');

const useStore = create(set => ({
  ...onboardingSlice(set),
  ...adsTxtSlice(set),
  ...ticketsSlice(set),
  ...realtimeSlice(set),
  ...stackedReportSlice(set),
  googleAuth: false,
  disableTypingForAccountSelector: false,
  analyticsFiltersOpen: false,
  openedSidebarSection: false,
  profileMenuOpen: false,
  visiblePopup: null,
  propertiesSelectionScrollOffset: 0,
  startingDay: startingDay,
  collapsedDomains: [],
  MCMstatuses: {},
  selectedSection: 0,
  calculated: null,
  publishers: null,
  selectionLabel: null,
  showSectionsTooltip: lscache.get('tabsTooltipSeen'),
  activeBillingSection: 0,
  dataType: 'combined',
  period: (() => {
    const startDate = moment(startingDay).subtract(30, 'days').format('YYYY-MM-DD');
    const endDate = moment(startingDay).subtract(1, 'days').format('YYYY-MM-DD');
    return {label: 'Last 30 days', startDate, endDate};
  })(),
  comparisonPeriod: (() => {
    const startDate = moment(startingDay).subtract(30, 'days').format('YYYY-MM-DD');
    const endDate = moment(startingDay).subtract(1, 'days').format('YYYY-MM-DD');
    return buildComparisonPeriod(startDate, endDate);
  })(),
  selection: {
    value: {
      publisher: null,
      placement: null,
      domain: null,
    },
  },
  assignedGoogleProperties: null,
  pricesReportData: null,
  pricesReportCacheKey: null,

  // Global state change function, two params - first is key of state, second is data
  setState: (key, data) => {
    set(() => ({
      [key]: data,
    }));
  },
}));

export default useStore;
